import React, { useState, useEffect } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/Questions.css';
import '../Styles/UserTypes.css';
import { useSidebar } from '../Layout/SidebarContext';

const Questions = () => {
  const { isConfigOpen } = useSidebar();

  const [questions, setQuestions] = useState([
    {
      id: 1,
      type: 'What is your experience with Software?',
      description: 'Software Questions',
      options: [
        { option: 'Good' },
        { option: 'Poor' },
        { option: 'Average' },
      ],
    },
    { id: 2, type: 'Which software do you use?', description: 'Hardware Questions', options: [] },
  ]);

  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [options, setOptions] = useState([]);
  const [newOption, setNewOption] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingOption, setEditingOption] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  useEffect(() => {
    if (selectedQuestion) {
      const question = questions.find((q) => q.type === selectedQuestion);
      setOptions(question ? question.options : []);
    }
  }, [selectedQuestion, questions]);

  const handleAddOption = () => {
    if (newOption) {
      const updatedOptions = [
        ...options,
        { option: newOption },
      ];
      setOptions(updatedOptions);
      setNewOption('');
      setIsPopupOpen(false);
    }
  };


  const handleCancelEdit = () => {
    setIsPopupOpen(false);
  };

  const handleEditOption = (index) => {
    setEditingOption({ index, ...options[index] });
    setShowModal(true);
  };

  const handleSaveEdit = () => {
    const updatedOptions = [...options];
    updatedOptions[editingOption.index] = {
      option: editingOption.option,
    };
    setOptions(updatedOptions);
    setShowModal(false);
    setEditingOption(null);
  };

  const handleDeleteOption = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true); // Show the delete confirmation modal
  };

  const handleConfirmDelete = () => {
    const updatedOptions = options.filter((_, i) => i !== deleteIndex);
    setOptions(updatedOptions);
    setConfirmDelete(false); // Close the delete confirmation modal
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false); // Close the delete confirmation modal
    setDeleteIndex(null);
  };

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Manage Options</h2>
      </div>

      {/* Dropdown for Question Selection */}
      <div className="solution-selection-dropdown">
        <select onChange={(e) => setSelectedQuestion(e.target.value)} value={selectedQuestion}>
          <option value="">Select Question</option>
          {questions.map((question) => (
            <option key={question.id} value={question.type}>
              {question.type}
            </option>
          ))}
        </select>
      </div>

      {/* Options */}
      {selectedQuestion && (
        <div className="questions-container">
          <table className="user-types-table">
            <thead>
              <tr>
                <th>
                  <MdAdd size={24} color="#1e3c72" onClick={() => setIsPopupOpen(true)} />
                </th>
                <th>Option</th>
              </tr>
            </thead>
            <tbody>
              {options.length > 0 ? (
                options.map((opt, index) => (
                  <tr key={index}>
                    <td>
                      <FaEdit
                        size={15}
                        style={{ cursor: 'pointer', color: '#00bfa5' }}
                        onClick={() => handleEditOption(index)}
                      />
                      <FaTrash
                        size={15}
                        color="#f44336"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteOption(index)}
                      />
                    </td>
                    <td>{opt.option}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No options available for this question.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Add New Option Modal */}
      {isPopupOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Option</h3>
            <input
              type="text"
              placeholder="Enter Option"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
            />
            <div className="modal-actions">
              <button onClick={handleAddOption}>Add</button>
              <button onClick={handleCancelEdit}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Option Modal */}
      {showModal && editingOption && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Option</h3>
            <input
              type="text"
              value={editingOption.option}
              onChange={(e) =>
                setEditingOption({ ...editingOption, option: e.target.value })
              }
            />
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Modal */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this option?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Questions;
